export default __webpack_public_path__ + "static/media/loading.c3ed2bc1.gif";